export default __webpack_public_path__ + "static/output-b7cdab53f8b4f9308fb9ed7e7235f431.webm";